export default "__VITE_ASSET__36354c10__"